const ACTION_FORMATTERS = {
  reevaluate: (level) => `اعادة التقييم على ${level}`,
  promote: (level) => `الترفيع الى مستوى ${level}`,
  demote: (level) => `تخفيض الى مستوى ${level}`,
  keep: (level) => `الابقاء في مستوى ${level}`,
};

export const formatRecommendationAction = (recommendation, levels = []) => {
  if (!recommendation) return "";
  if (typeof recommendation === "string") return recommendation;

  const { action, level, levelId } = recommendation ?? {};

  const resolvedLevel =
    level ??
    levels.find((item) => item?.id === levelId || item?._id === levelId);

  const levelCode = resolvedLevel?.code;

  const normalizedAction = action?.toLowerCase().replace(/[-_]/g, "");

  const formatter = ACTION_FORMATTERS[normalizedAction];

  if (formatter) {
    return formatter(levelCode);
  }

  return [action, levelCode].filter(Boolean).join(" ");
};

export default formatRecommendationAction;
